import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Textarea,
} from '@chakra-ui/react';
import CountrySelect from '../common/CountrySelect';

const OrganizationGeneralFields = ({
  values,
  onChange,
  sectionBg,
  showNotes = true,
  labels = {},
}) => {
  const l = (key, fallback) => labels[key] || fallback;

  return (
    <>
      <Box bg={sectionBg} p={4} borderRadius="md">
        <Heading as="h4" size="sm" mb={2}>
          {l('generalInfo', 'General Information')}
        </Heading>
        <FormControl isRequired>
          <FormLabel>{l('name', 'School name')}</FormLabel>
          <Input name="name" value={values.name || ''} onChange={onChange} />
        </FormControl>
        <FormControl mt={3}>
          <FormLabel>{l('contact', 'Contact person')}</FormLabel>
          <Input name="contact" value={values.contact || ''} onChange={onChange} />
        </FormControl>
        <FormControl mt={3}>
          <FormLabel>{l('title', 'Title')}</FormLabel>
          <Input name="title" value={values.title || ''} onChange={onChange} />
        </FormControl>
      </Box>

      <Box bg={sectionBg} p={4} borderRadius="md">
        <Heading as="h4" size="sm" mb={2}>
          {l('contactInfo', 'Contact Information')}
        </Heading>
        <FormControl isRequired>
          <FormLabel>{l('email', 'Email')}</FormLabel>
          <Input name="email" type="email" value={values.email || ''} onChange={onChange} />
        </FormControl>
        <FormControl mt={3}>
          <FormLabel>{l('phone', 'Phone')}</FormLabel>
          <Input name="phone" value={values.phone || ''} onChange={onChange} />
        </FormControl>
      </Box>

      <Box bg={sectionBg} p={4} borderRadius="md">
        <Heading as="h4" size="sm" mb={2}>
          {l('location', 'Location')}
        </Heading>
        <FormControl mt={3}>
          <FormLabel>{l('address', 'Address')}</FormLabel>
          <Input name="address" value={values.address || ''} onChange={onChange} />
        </FormControl>
        <FormControl mt={3}>
          <FormLabel>{l('city', 'City')}</FormLabel>
          <Input name="city" value={values.city || ''} onChange={onChange} />
        </FormControl>
        <FormControl mt={3}>
          <FormLabel>{l('state', 'State')}</FormLabel>
          <Input name="state" value={values.state || ''} onChange={onChange} />
        </FormControl>
        <FormControl mt={3}>
          <FormLabel>{l('country', 'Country')}</FormLabel>
          <CountrySelect
            name="country"
            value={values.country || ''}
            onChange={onChange}
            placeholder={l('countryPlaceholder', 'Select country')}
          />
        </FormControl>
        <FormControl mt={3}>
          <FormLabel>{l('zip', 'Zip')}</FormLabel>
          <Input name="zip" value={values.zip || ''} onChange={onChange} />
        </FormControl>
      </Box>

      {showNotes ? (
        <Box bg={sectionBg} p={4} borderRadius="md">
          <Heading as="h4" size="sm" mb={2}>
            {l('notes', 'General Notes')}
          </Heading>
          <FormControl>
            <FormLabel>{l('notes', 'General Notes')}</FormLabel>
            <Textarea
              name="notes"
              value={values.notes || ''}
              onChange={onChange}
              placeholder={l('notesPlaceholder', 'Add notes')}
            />
          </FormControl>
        </Box>
      ) : null}
    </>
  );
};

export default OrganizationGeneralFields;
